var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "avatarCropper",
      style: { width: _vm.size + "px", height: _vm.size + "px" },
    },
    [
      !_vm.value
        ? _c(
            "div",
            [
              _vm.fileList.length < _vm.maxLength
                ? _c(
                    "el-upload",
                    {
                      ref: "upload",
                      staticClass: "uploadView",
                      style: {
                        width: _vm.size + "px",
                        height: _vm.size + "px",
                      },
                      attrs: {
                        disabled: _vm.disabled,
                        action: "#",
                        limit: 1,
                        accept: ".jpg,.jpeg,.png",
                        "before-upload": _vm.beforeUpload,
                        "http-request": _vm.upload,
                        "show-file-list": false,
                      },
                    },
                    [
                      _c("div", { staticClass: "aiAvatarBox" }, [
                        _c("img", {
                          staticClass: "aiAvatar",
                          style: {
                            width: _vm.size + "px",
                            height: _vm.size + "px",
                          },
                          attrs: {
                            src: require("@/assets/image/aigc/aiAvatar.png"),
                            alt: "",
                          },
                        }),
                        _c("img", {
                          staticClass: "aiAvatarAdd",
                          attrs: {
                            src: require("@/assets/image/aigc/aiAvatarAdd.png"),
                            alt: "",
                          },
                        }),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._l(_vm.fileList, function (item, index) {
                return [
                  _c("uploadItem", {
                    key: index,
                    staticClass: "m-r-16",
                    attrs: {
                      status: item.status,
                      "err-tips": item.errTips,
                      url: item.url,
                      accept: ".jpg,.jpeg,.png,.gif",
                      width: _vm.size,
                      disabled: _vm.disabled,
                      height: _vm.size,
                      "auth-progress": item.authProgress,
                      "before-upload": _vm.beforeUpload,
                    },
                    on: {
                      del: function ($event) {
                        return _vm.delFile(item, index)
                      },
                      again: function ($event) {
                        return _vm.alignUpload(item, index)
                      },
                      upload: _vm.upload,
                      onClick: (res) => _vm.$emit("onClick", res),
                    },
                  }),
                ]
              }),
            ],
            2
          )
        : _c(
            "div",
            { staticClass: "aiAvatarBox" },
            [
              _c("AppMyImage", {
                staticStyle: {
                  width: "100px",
                  height: "100px",
                  "border-radius": "50%",
                  overflow: "hidden",
                  "object-fit": "fill",
                },
                attrs: {
                  src: _vm.value,
                  fit: "fill",
                  options: {
                    width: 567,
                    fixed: true,
                    option: {
                      fixed: true,
                      fixedNumber: [1, 1],
                      fixedBox: false,
                    },
                  },
                },
                on: { close: _vm.delImage, success: _vm.changeImage },
              }),
            ],
            1
          ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }